import config from "config"
import { alpha } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const mixins = {
  vKioskHeader: {
    height: 285, // kiosk header
  },
  vKioskFooter: {
    height: 300, // kiosk footer
  },
  kioskNavigation: {
    height: 240,
  },
  bottomNavigation: {
    height: 82,
  },
  mobileHeader: {
    height: 56,
  },
  mobileDirectionSearch: {
    width: 380,
  },
  desktopHeader: {
    height: 65,
  },
}

export const themeOptionFactory = (theme) => ({
  mixins,
  assets: {
    /**
     * The icon configuration format for pages with no data.
     * Example:
     * promotions: {
     *   "icon_comp": "_COMPONENT_NAME_", // optional
     *   "icon_path": "_SVG_PATH_", // optional
     *   "url: ": "_IMG_SRC_", // optional
     * }
     */
    empty: {
      promotions: {},
      events: {},
      dining: {},
      newShops: {},
      directory: {},
      touristPrivilege: {},
    },
    /**
     * The platform's application logo.
     */
    platforms: {
      hungryhub: {
        url: "https://s3.venue.in.th/A_Idro_l_Tu_L_kv_SBUZW_Yuq_ISO_Bx_Ve_W_Ud_O2_Pnbedds_R_Kghe_S_Cz_Q_s900_c_k_c0x00ffffff_no_rj_c0581c6d35.jpeg",
      },
      queq: {
        url: "https://s3.venue.in.th/y_L_bck_Ze_HH_0oj_DL_Yute_DVQ_Tqz_CY_9um_R2e_N4j0lg0xt0qsp_Z6_IGA_Bxjsd_U_Ng_YGB_94mw_dfc33a12b5.png",
      },
      "lineman-wongnai": {
        url: "https://s3.venue.in.th/xq_HA_S_Yn_WC_3_HYA_Qi1_J_Zg_MP_Fax_YX_2_WQ_Ly_twv44_YWC_9_Q_N_Xe_BUM_Avj_PZZ_1a_N8_U7k_Nj8w_1e5e370eff.png",
      },
      eatable: {
        url: "https://s3.venue.in.th/l_K_Ovo4pjjn_NBS_Yi_Hc5a_Ak_N_2n_Bl_Zd_T_To_J_Ea6_Gq_Xes_OF_g_Ae_P1_Rjrr_BFG_6mng_Iu_P_Akw_5fdd964546.png",
      },
      openrice: {
        url: "https://s3.venue.in.th/e_HPT_6_Rvg_P_Cvp_Tv3m_Iz_Ve_LSH_Nc_R2_Ld_L_Prisuc_W_Aw_HFQJ_Vi_Q_One5wy19b_NSL_2eqbpkjc_Y_81c808f384.png",
      },
      gowabi: {
        url: "https://s3.venue.in.th/images_63738e7e38.jpeg",
      },
      klook: {
        url: "https://s3.venue.in.th/oi_Wp_ZPNU_77_Yig_Mo_C1ia_Xds_X_Do_U34_PWP_63_M5c0e_ZCR_l6_O3_WT_Pn_D48_Cubgmto_Q_Eah_P_w_de9ea54f47.png",
      },
      eatigo: {
        url: "https://s3.venue.in.th/uz2_M4x_CF_Myr_Yk_Y_Elyw8_AVM_Rey_In_Q_Wxa0f_CMK_Adza_Ndm_ZB_9_IE_Es_K_Qzrj_HIA_93pg_SU_ee5069fa31.png",
      },
      booking: {
        url: "https://s3.venue.in.th/3_Kf2_Yyo_yg14_Js9_QSZNGT_Az_Vt_Zdl_Eaxce_PVCD_Hza_Ph_AH_6u_E_Vd_T7l_Ttz19_Yrx1po_Vbpal_s256_rw_ba5c09394c.webp",
      },
      agoda: {
        url: "https://s3.venue.in.th/Q_Fl5_Rn_Jn_Ca_Apuw_SY_5_Gky_Pk1_Yq_F_Rdeq_64_E_Hae_Ne_Y_Id3_Hw_Y9_Uqjf5_Jk_R_Ve_AT_Zxuu_Kez5o_08a5bc0a66.png",
      },
      tripadvisor: {
        url: "https://s3.venue.in.th/Eo_Rc_Rtru5_F_Lis_Rd0k_CJ_5_Ee_Tb_DQS_8o_Zt_LYI_Tsg_58_Gv52ryuj_Jtq_Yw_QU_Yf_D_Dw_Y3_Y9c2_U_a93799697d.png",
      },
      resy: {
        url: "https://s3.venue.in.th/Nli_O_Gci_JF_8_v8m_T_Pj_Dn_FI_4_L_qrtmqz_G0_C_Tx5u0_LH_Ug_FMNO_66_QB_1q_Hw_Kf_Wfip_DVHHY_048b1a4c6b.png",
      },
      opentable: {
        url: "https://s3.venue.in.th/6_EU_Alv_RT_1_Umzip_X_Vyvtlt_Q0n_Lh_OLB_wkghb_HEI_Bdsczl4_Ln_Eh_W6o7e_HS_Zhxa_Ay0_Wc_eade25cd18.png",
      },
      tablecheck: {
        url: "https://s3.venue.in.th/Table_Check_jpg_e4abf4794b.aspx",
      },
      facebook: {
        url: "https://s3.venue.in.th/KCMT_Yui_Tr_Kom4_Vyf0_G4foet_V_Owh_K_Wz_Nb_H_Wum_V73_I_Xex_A_Iy5_T_Tg_Zip_L52_W_Tt8_ICL_o_Io_01a299e85c.png",
      },
      instagram: {
        url: "https://s3.venue.in.th/VRM_Wk_E5p3_Ck_Wh_Js6nv_9_Zs_L_As1_Q_Og5ob1_3qg_rckw_YW_7yp1f_Mr_Y_Zqn_E_Fpk0_Io_VP_4_LM_12f0569ace.png",
      },
      line: {
        url: "https://s3.venue.in.th/74i_M_Ob_G1vs_R3_Kfm82_Rj_ER_Fhf99_QFMNIY_211o_Mv_N636_g_U_Lghb_RB_Mjp_VF_Tj_OK_36ox_Cbs_50869ab4b3.png",
      },
      "twitter-x": {
        url: "https://s3.venue.in.th/A_Rnrh0_J7i_Km_A_Bsk_Tonq_FAANRLGTG_Ug_nu_E4_PEM_Yw_Jav_L3n_Pt5u_Ws_U2_WO_D_Sg_V_m_OOM_4485813680.png",
      },
      tiktok: {
        url: "https://s3.venue.in.th/Bm_U_Vi_DVOKN_Je0_GY_Je22hsr7ju_Fnd_R_Vbvr1f_Gm_HG_Xq_Hf_Jj_NA_Xjd26bfu_GR_Qp_Vrp_J6_Yb_A_35a4e2b103.png",
      },
      youtube: {
        url: "https://s3.venue.in.th/6am0i3wal_Yw_N_Lc08_QO_Oh_R_Jtt_QENN_Gkhl_Kaj_XSE_Rf3_Jn_PVR_Qcz_Iyxw2w3_Dxe_MRTO_Sds_Y_f4eff792ef.png",
      },
      threads: {
        url: "https://s3.venue.in.th/G6j_K9_S77_RN_0laf9_6nh_Do3_A_Vxb_RP_9_Sg_Mmt8_Zm_Qj_KQ_2hibn9xh_OY_W5_Y_Fn_7st_JD_1_CA_ee64a782ec.png",
      },
      chope: {
        url: "https://s3.venue.in.th/chope_fc476e0327.png",
      },
      jpneasy: {
        url: "https://s3.venue.in.th/jpneasy_fd9e457b0f.png",
      },
    },
    storeDownload: {
      ios: {
        url: "https://s3.venue.in.th/ios_store_download_button_f012d18f26.png",
      },
      android: {
        url: "https://s3.venue.in.th/store_download_button_70d404d1a9.png",
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        /* Override style to apply solid color filter for CustomImageIcon component. */
        "#searchListItem_avatar_filter .solid-color-filter": {
          // display: "none" // Disable filter
          // floodColor: "currentColor" // Set solid color (default: currentColor).
        },
        "#diningCard_cover_filter .solid-color-filter": {},
        "#diningCard_avatar_filter .solid-color-filter": {},
        "#directoryCard_avatar_filter .solid-color-filter": {},
        "#placeDetail_avatar_filter .solid-color-filter": {},
        "#shopPromotion_avatar_filter .solid-color-filter": {},
        "#step_avatar_filter .solid-color-filter": {},
        "#directionOverview_avatar_filter .solid-color-filter": {},
        "#stepOverview_avatar_filter .solid-color-filter": {},
        "#newShop_cover_filter .solid-color-filter": {},
        "#newShop_avatar_filter .solid-color-filter": {},
        "#comingShop_cover_filter .solid-color-filter": {},
        "#comingShop_avatar_filter .solid-color-filter": {},
        /* End Override style to apply solid color filter for CustomImageIcon component. */
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          padding: 0,
          width: "fit-content",
          height: "20px",
        },
        switchBase: {
          padding: 0,
          margin: theme.spacing(1.4),
          marginTop: theme.spacing(0.2),
          transitionDuration: theme.transitions.duration.standard,
          "&.MuiButtonBase-root:hover": {
            backgroundColor: "transparent",
          },
          "&.Mui-checked": {
            transform: "translateX(7px)",
            color: theme.palette.primary.contrastText,
            "& + .MuiSwitch-track": {
              backgroundColor: theme.palette.primary.main,
              opacity: 1,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.5,
            },
          },
          "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: theme.palette.primary.main,
            border: `6px solid ${theme.palette.primary.contrastText}`,
          },
          "&.Mui-disabled .MuiSwitch-thumb": {
            color: theme.palette.grey[100],
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.7,
          },
        },
        thumb: {
          boxSizing: "border-box",
          width: "16px",
          height: "16px",
          marginLeft: theme.spacing(-1),
        },
        track: {
          width: "30px",
          height: "20px",
          borderRadius: "10px",
          backgroundColor: theme.palette.grey[300],
          opacity: 1,
          transition: theme.transitions.create(["background-color"], {
            duration: 500,
          }),
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          width: "100%",
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[10],
          height: mixins.bottomNavigation?.height,
          padding: theme.spacing(0, 6.75),
          gap: 10,
          [theme.breakpoints.up("sm")]: {
            width: "auto",
            gap: 40,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          },
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 1, 1),
          [theme.breakpoints.up("md")]: {
            maxWidth: "none",
            borderRadius: "unset",
          },
          "& .MuiSvgIcon-root": {
            marginBottom: 8,
            width: 20,
            height: 20,
          },
          "&.Mui-selected": {
            "&:after": {
              content: "''",
              display: "block",
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              height: "4px",
              width: "100%",
              borderRadius: 9999,
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        label: {
          textAlign: "center",
          fontSize: "0.875rem",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[500],
          "&.Mui-disabled": {
            backgroundColor: "#ECECEC",
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreIcon,
      },
      styleOverrides: {
        select: {
          padding: theme.spacing(1.5, 4, 1.5, 2),
          borderRadius: "8px",
          fontSize: 12,
        },
        icon: {
          color: theme.palette.primary.main,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          fontSize: "0.75rem",
        },
      },
    },
    AppSidebar: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(3),
          backgroundColor: theme.palette.grey[50],
          width: "100%",
          [theme.breakpoints.up("sm")]: {
            maxWidth: "428px",
          },
        },
        header: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        },
        headerTitle: {
          display: "none",
        },
        body: {
          flexGrow: 1,
          overflowX: "hidden",
          overflowY: "auto",
        },
        footer: {},
        footerLogo: {},
        flagIcon: {
          background: "transparent",
          borderRadius: "2px",
          aspectRatio: "1.5/1",
          width: "20px",
          height: "auto",
          "& .MuiSvgIcon-root": {
            fill: "currentColor",
          },
        },
        currentFlagIcon: {
          display: "inline-flex",
        },
        fallbackFlagIcon: {
          display: "none",
          height: "24px",
        },
        closeButton: {
          position: "absolute",
          right: "32px",
          top: "24px",
          zIndex: 1,
          "& .MuiSvgIcon-root": {
            width: "14px",
            height: "14px",
            fontSize: "14px",
            fill: theme.palette.text.primary,
          },
        },
        expandIcon: {
          display: "none",
          width: "20px",
          height: "20px",
          marginRight: theme.spacing(1.5),
        },
        navList: {},
        navDivider: {
          borderBottomWidth: "1px",
          margin: theme.spacing(0, 3),
          "&+ .MuiDivider-root": {
            display: "none",
          },
        },
        navListItem: {
          padding: theme.spacing(1.375, 3),
          "& .MuiTypography-root": {
            fontWeight: 500,
            fontSize: "1rem",
            color: theme.palette.text.secondary,
          },
          "& .MuiListItemIcon-root": {
            color: theme.palette.primary.main,
            minWidth: 40,
          },
          "& .MuiSvgIcon-root": {
            fontSize: "1.125rem",
          },
          [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(2, 3),
            "& .MuiTypography-root": {
              fontSize: "1.125rem",
            },
            "& .MuiSvgIcon-root": {
              fontSize: "1.25rem",
            },
          },
        },
        subList: {},
        subDivider: {
          marginLeft: theme.spacing(8),
          borderBottomWidth: "1px",
        },
        subListItem: {
          paddingLeft: theme.spacing(8),
          color: "inherit",
          "& .MuiTypography-root": {
            fontWeight: 500,
            fontSize: "0.875rem",
            color: theme.palette.text.secondary,
          },
          "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall": {
            fontSize: "0.5rem",
          },
          "& .MuiListItemIcon-root": {
            color: theme.palette.primary.main,
            minWidth: "30px",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "1rem",
          },
          "&:last-of-type": {
            borderBottom: "none",
          },
          "&:last-of-type + .MuiDivider-root": {
            display: "none",
          },
        },
        languageSelectorWrapper: {
          "& .MuiList-root .MuiDivider-root": {
            display: "none",
          },
        },
      },
    },
    AppDining: {
      styleOverrides: {
        root: {},
        filterSection: {
          margin: theme.spacing(0, -3),
        },
        filterContainer: {
          padding: theme.spacing(0, 0, 3, 0),
        },
        filterButton: {
          gap: theme.spacing(1),
          padding: 0,
          "& .MuiToggleButton-root": {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(3),
            [theme.breakpoints.up("md")]: {
              marginLeft: theme.spacing(6),
            },
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(3),
            [theme.breakpoints.up("md")]: {
              marginRight: theme.spacing(6),
            },
          },
          whiteSpace: "nowrap",
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
        },
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1),
        },
        diningImageCard: {
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
        },
        emptyDataContainer: {
          height: `calc(100vh - ${mixins.mobileHeader?.height}px - ${
            mixins.bottomNavigation?.height + 30
          }px - 72px)`,
          // Prevent content page overlap with footer shadow by adding a bottom space (30px)
          //72 px is container padding
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        venueSelector: {
          position: "fixed",
          bottom: mixins.bottomNavigation?.height + 45,
          right: "24px",
          zIndex: 1, // Prevents restaurants' info from appearing on top
        },
        pageLayout: {},
        levelHeader: {
          display: "flex",
          width: "100%",
          gap: theme.spacing(3),
          position: "sticky",
          top: 108,
          background: theme.palette.background.paper,
          zIndex: 10,
          fontWeight: 700,
          fontSize: "1rem",
          padding: theme.spacing(1.5, 0),
          gridColumn: "1 / -1",
        },
        divider: {
          flex: 1,
          alignSelf: "center",
          borderColor: theme.palette.divider,
          borderWidth: "1px",
        },
      },
    },
    AppCategoryFilterButton: {
      styleOverrides: {
        root: {
          padding: 0,
          width: 70,
          flexDirection: "column",
          justifyContent: "start",
          gap: theme.spacing(0.75),
          border: "none",
          backgroundColor: theme.palette.primary.contrastText,
          color: theme.palette.grey[500],
          ":hover": {
            "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
              border: `1px solid ${theme.palette.grey[200]}`,
            },
          },
          "&.Mui-selected": {
            "& .MuiSvgIcon-root": {
              color: theme.palette.primary.main,
            },
            "& .MuiTypography-root": {
              color: theme.palette.primary.main,
            },
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "unset",
          },
        },
        label: {
          fontSize: "0.625rem",
          textAlign: "center",
          lineHeight: 1.1,
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightMedium,
        },
        icon: {
          padding: theme.spacing(1.25),
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          border: `1px solid rgba(203, 203, 203, 0.5)`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "30px",
            height: "30px",
          },
        },
      },
    },
    AppCategoryFilterChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5),
          borderRadius: "16px",
          boxShadow: "none",
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.grey[200]}`,
          whiteSpace: "nowrap",
          height: "auto",
          color: theme.palette.text.primary,
          fontWeight: 400,
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "16px",
          },
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: "16px",
          },
          "&.Mui-selected": {
            "& svg": {
              fill: theme.palette.primary.contrastText,
            },
          },
        },
        label: {
          fontSize: "0.8125rem",
          padding: theme.spacing(0, 1.5),
          letterSpacing: "0.00938em",
        },
        icon: {
          "& svg": {
            width: 16,
            height: 16,
            fill: theme.palette.primary.main,
            marginLeft: theme.spacing(0.5),
            marginRight: "-6px",
          },
        },
      },
    },
    AppCategoryFilterBar: {
      styleOverrides: {
        root: {},
        filterButton: {},
      },
    },
    WelcomePanel: {
      defaultProps: {
        showNavigation: false,
        showQuickSearch: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[50],
        },
        panelContainer: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
        },
        line: {
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "3px",
          border: "none",
          background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.common.white} 100%)`,
        },
        content: {
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          [theme.breakpoints.up("md")]: {
            margin: "0 auto",
            width: "100%",
            maxWidth: "900px",
          },
        },
        logoContainer: {
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          marginBottom: theme.spacing(3),
          padding: theme.spacing(1.25, 10),
          "& img": {
            maxWidth: 130,
            [theme.breakpoints.up("md")]: {
              maxWidth: 380,
            },
          },
        },
        searchBarContainer: {
          marginBottom: theme.spacing(2),
          width: "100%",
        },
        navItem: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          color: "white",
          flexBasis: 0,
          fontSize: theme.typography.subTitle.fontSize,
          fontWeight: theme.typography.fontWeightRegular,
          lineHeight: "19px",
          flexGrow: "1",
          textAlign: "center",
          "& .MuiButton-startIcon": {
            margin: theme.spacing(0, 0, 1.5),
            width: 20,
            height: 20,
          },
        },
        horizontalMenuContainer: {
          padding: 0,
          "& .MuiToggleButtonGroup-root": {
            "& .MuiToggleButtonGroup-grouped:first-of-type": {
              marginLeft: 0,
            },
          },
        },
        featureChipToggleBar: {},
      },
    },
    AppHeader: {
      styleOverrides: {
        root: {
          position: "relative",
          backgroundColor: theme.palette.primary.main,
          boxShadow: "none",
          width: "100%",
          fontSize: "1.25rem",
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          textAlign: "center",
          zIndex: 1200,
        },
        toolbar: {
          minHeight: mixins.mobileHeader.height,
          justifyContent: "space-between",
          padding: theme.spacing(1.5, 2),
          width: `100%`,
          [theme.breakpoints.up("md")]: {
            margin: 0,
            height: mixins.desktopHeader.height,
          },
        },
        logoContainer: {
          display: "none",
          [theme.breakpoints.up("md")]: {
            display: "flex",
          },
        },
        logoImage: {
          height: "65px",
          padding: theme.spacing(1.75),
        },
        titleContainer: {
          width: "100%",
          fontSize: "1.75rem",
          textAlign: "start",
          [theme.breakpoints.up("md")]: {
            display: "none",
          },
        },
        clockContainer: {
          display: "none",
        },
        backButtonContainer: {
          display: "none",
          "& .MuiButtonBase-root": {
            backgroundColor: theme.palette.grey[100],
            padding: theme.spacing(1),
            "& .MuiSvgIcon-root": {
              width: "16px",
              height: "16px",
            },
          },
          [theme.breakpoints.up("md")]: {
            display: "none",
          },
        },
        languangeContainer: {
          display: "none",
          [theme.breakpoints.up("md")]: {
            display: "block",
          },
        },
        line: {
          display: "none",
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          border: "none",
        },
        searchContainer: {
          position: "absolute",
          right: 16,
          display: "flex",
          padding: 0,
          alignItems: "center",
          justifyContent: "center",
          "& .MuiButtonBase-root": {
            width: 32,
            height: 32,
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            borderRadius: "50%",
            [theme.breakpoints.up("md")]: {
              width: "100%",
              height: "40px",
              justifyContent: "flex-start",
              borderRadius: "32px",
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.primary.main}`,
              padding: theme.spacing(0.5, 2),
            },
          },
          "& svg": {
            color: theme.palette.common.white,
            width: "14px",
            margin: 0,
            [theme.breakpoints.up("md")]: {
              color: theme.palette.grey[600],
              width: "18px",
              height: "18px",
              marginRight: theme.spacing(1.5),
            },
          },
          "& .MuiTypography-root": {
            display: "none",
            [theme.breakpoints.up("md")]: {
              display: "block",
            },
          },
          [theme.breakpoints.up("md")]: {
            display: "block",
            width: 440,
            position: "absolute",
            transform: "translateX(-50%)",
            left: "50%",
          },
        },
        shareContainer: {
          display: "none",
          "& .MuiButtonBase-root": {
            backgroundColor: theme.palette.grey[100],
            "& .MuiSvgIcon-root": {
              width: "16px",
              height: "16px",
              "& path": {
                fill: theme.palette.grey[800],
              },
            },
          },
        },
      },
    },
    AppPageLayout: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          minHeight: `calc(100vh - ${mixins.bottomNavigation?.height}px)`,
          paddingBottom: `${mixins.bottomNavigation?.height}px`,
          backgroundColor: theme.palette.background.paper,
          [theme.breakpoints.up("md")]: {
            paddingBottom: 0,
            minHeight: "100%",
            background: "transparent",
            backgroundColor: "transparent",
          },
        },
        headerContainer: {
          display: "none",
          position: "fixed",
          height: mixins.mobileHeader.height,
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          [theme.breakpoints.up("md")]: {
            display: "block",
            position: "fixed",
            width: "100%",
            zIndex: 1301,
          },
        },
        headerBackIconContainer: {
          marginRight: 2,
          backgroundColor: "#fff",
          borderRadius: "50%",
          "& button": {
            height: "100%",
            width: "100%",
            margin: "auto",
          },
        },
        navigationContainer: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
          [theme.breakpoints.up("md")]: {
            top: mixins.desktopHeader.height,
            width: "138px",
          },
        },
        container: {
          padding: `${mixins.mobileHeader?.height}px 16px 16px 16px`,
          [theme.breakpoints.up("md")]: {
            width: "100%",
            maxWidth: "calc(100% - 138px)",
            position: "absolute",
            left: "138px",
            top: mixins.desktopHeader.height,
            padding: 0,
          },
        },
        headerWrapper: {},
        LanguageButton: {},
      },
    },
    AppClock: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          textTransform: "uppercase",
          whiteSpace: "pre-wrap",
          lineHeight: 1.2,
        },
        timeWrapper: {
          textAlign: "left",
          fontSize: "50px",
        },
        dateText: {
          textAlign: "right",
          fontSize: "30px",
        },
        timeLabel: {
          fontWeight: 300,
          fontSize: "16px",
        },
        timeText: {},
        timeUnitText: {
          fontWeight: 300,
          fontSize: "16px",
          marginBottom: theme.spacing(2),
        },
      },
    },
    AppMobileNavigation: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
        },
        menuButton: {},
        moreButton: {
          textAlign: "center",
        },
      },
    },
    AppDesktopNavigation: {
      styleOverrides: {
        root: {
          width: "100%",
          height: "100%",
          borderRight: `1px solid ${theme.palette.divider}`,
          "& .MuiBottomNavigation-root": {
            padding: 0,
            gap: 0,
            height: "100%",
            flexDirection: "column",
            justifyContent: "flex-start",
            boxShadow: "none",
            borderRadius: 0,
          },
        },
        menuButton: {
          padding: theme.spacing(2),
          width: "auto",
          minWidth: "inherit",
          gap: theme.spacing(0.5),
          flex: "none",
          flexDirection: "row",
          justifyContent: "unset",
          ":after": {
            content: "''",
            position: "absolute",
            right: 0,
            left: "unset",
            borderRadius: 0,
            background: "transparent",
            width: "4px",
            height: "100%",
          },
          "&.Mui-selected": {
            ":after": {
              content: "''",
              position: "absolute",
              right: 0,
              left: "unset",
              borderRadius: 0,
              background: theme.palette.secondary.main,
              width: "4px",
              height: "100%",
            },
            background: theme.palette.primary.main,
            "& .MuiBottomNavigationAction-label": {
              fontSize: "0.875rem",
              color: theme.palette.primary.contrastText,
              backgroundClip: "text",
            },
            "& .MuiSvgIcon-root": {
              color: theme.palette.primary.contrastText,
            },
          },
          "& .MuiSvgIcon-root": {
            color: theme.palette.secondary.main,
            width: theme.spacing(3),
            height: theme.spacing(3),
            marginBottom: 0,
          },
          "& .MuiBottomNavigationAction-label": {
            color: theme.palette.secondary.main,
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "112%",
          },
        },
      },
    },
    AppKioskNavigation: {
      styleOverrides: {
        root: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: mixins.vKioskFooter.height,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: theme.spacing(0, 6.25),
        },
        menuButton: {
          width: 138,
          "& .MuiSvgIcon-root": {
            marginBottom: theme.spacing(2),
            width: 32,
            height: 32,
          },
        },
        navigationContainer: {
          width: "auto",
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[6],
          marginBottom: theme.spacing(3),
          maxWidth: 979,
          height: 127,
          borderRadius: "20px",
          padding: 0,
          [theme.breakpoints.up("sm")]: {
            maxWidth: "inherit",
            borderRadius: "20px",
            gap: 0,
          },
        },
        toolbarContainer: {
          display: "flex",
          flexDirection: "row",
          marginBottom: theme.spacing(3),
          width: "100%",
          boxShadow: "inherit",
          gap: theme.spacing(2),
        },
        searchBarContainer: {
          width: "100%",
          height: 48,
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.5),
        },
        actionButton: {
          minWidth: 128,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          "& .MuiSvgIcon-root": {
            marginRight: 0,
            width: 32,
            height: 32,
          },
        },
      },
    },
    AppNavigationLink: {
      styleOverrides: {
        root: {},
        backSide: {
          display: "none",
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          zIndex: 0,
        },
      },
    },
    AppMapLayout: {
      styleOverrides: {
        mapContainer: {
          width: "100%",
          position: "relative",
        },
        outletWrapper: {
          position: "relative",
        },
      },
    },
    AppFooter: {
      styleOverrides: {
        root: {},
      },
    },
    AppTopBar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 2),
          top: 0,
          position: "absolute",
          width: "fit-content",
          left: 0,
          right: 0,
          zIndex: theme.zIndex.modal,
        },
        ordinalSelector: {
          position: "static",
          "& .OrdinalSelector-root": {
            left: "unset",
            right: theme.spacing(2),
            bottom: theme.spacing(33),
            marginRight: theme.spacing(1.5),
            padding: theme.spacing(2, 1),
            width: "64px",
            boxShadow: "none",
            border: `1px solid #ececec`,
            backgroundColor: alpha(theme.palette.background.paper, 0.8),
          },
          "& .OrdinalSelector-list": {
            borderRadius: 9999,
            width: "48px",
            height: "48px",
            padding: 0,
            backgroundColor: theme.palette.background.paper,
            marginTop: theme.spacing(1),
          },
          "& .OrdinalSelector-label": {
            textAlign: "center",
            display: "block",
          },
          "& .OrdinalSelector-button": {
            height: "100%",
            fontWeight: 700,
          },
        },
        backButton: {
          width: "20px",
          height: "20px",
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.main,
          },
        },
      },
    },
    DirectionSearchInput: {
      styleOverrides: {
        directionSearchWrapper: {
          boxShadow: theme.shadows[1],
          background: theme.palette.common.white,
          padding: theme.spacing(3, 2),
          borderRadius: "10px",
          display: "flex",
        },
        backIconWrapper: {
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          marginRight: theme.spacing(1),
        },
        directionWrapper: {
          flexGrow: 1,
          display: "flex",
        },
        switchIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: theme.spacing(1),
        },
        directionInputWrapper: {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        },
        directionIconWrapper: {
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          marginRight: theme.spacing(1.5),
        },
        directionInput: {
          fontSize: "0.875rem",
          fontWeight: 500,
          flexGrow: 1,
          padding: theme.spacing(0, 0.5),
          "& .MuiInputBase-input": {
            padding: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        },
        iconButton: {
          color: theme.palette.text.primary,
          fontSize: "24px",
          margin: "-5px",
        },
        backIconButton: {},
        switchIconButton: {},
        connectorIcon: {},
        originIcon: {},
        destinationIcon: {},
        divider: {
          margin: theme.spacing(1, 0),
          borderBottomWidth: "1px",
        },
        clearIconButton: {
          color: theme.palette.text.primary,
          fontSize: "24px",
          margin: "-5px",
          "& .MuiSvgIcon-root": {
            height: "8px",
            width: "8px",
          },
        },
        endAdornmentWrapper: {
          display: "flex",
          gap: theme.spacing(1.5),
        },
        venueLogoContainer: {
          display: "none",
        },
        venueLogo: {
          width: "100%",
          height: "100%",
          backgroundSize: "contain",
        },
        venueName: {
          display: "none",
        },
      },
    },
    AppDirectionSearch: {
      styleOverrides: {
        headerWrapper: {
          padding: theme.spacing(3),
          [theme.breakpoints.up("sm")]: {
            maxWidth: mixins.mobileDirectionSearch.width,
          },
        },
        paper: {
          borderRadius: "10px",
          padding: theme.spacing(0.75, 1.25),
          display: "flex",
          alignItems: "center",
        },
        formControlLabel: {
          margin: 0,
          "& .MuiFormControlLabel-label": {
            fontWeight: 500,
            marginLeft: theme.spacing(2),
          },
        },
      },
    },
    AppMap: {
      styleOverrides: {
        toolbarContainer: {},
        quickLinkContainer: {
          overflowX: "scroll",
          padding: 0,
          display: "flex",
          maxWidth: "100%",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          [theme.breakpoints.up("md")]: {
            paddingLeft: theme.spacing(3),
            paddingTop: theme.spacing(3),
          },
        },
        navigationContainer: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        searchBarContainer: {
          padding: theme.spacing(3, 3, 1, 3),
          [theme.breakpoints.up("md")]: {
            display: "none",
          },
        },
        indoorMapContainer: {
          position: "absolute",
          zIndex: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          "& > #map": {
            width: "100%",
            height: "100%",
          },
          "& > * > .maptalks-wrapper": {
            transition: "all 500ms ease-out",
            // * Fixing Map transition not working when navigate from Directory to Place Detail.
            WebkitTransition: "-webkit-transform 500ms ease-out",
          },
          "&.bottom-half": {
            overflow: "hidden",
            "& .maptalks-wrapper": {
              transform: `translate(0, 24%)`,
            },
          },
          "&.hidden": {
            opacity: 0,
            visibility: "hidden",
          },
        },
        ordinalSelectMenu: {
          position: "fixed",
          bottom: "125px",
          right: "24px",
        },
        ordinalSelector: {
          display: "none",
        },
        venueSelector: {
          position: "fixed",
          bottom: mixins.bottomNavigation?.height + 45,
          left: "24px",
        },
        locationButtonContainer: {
          display: "none",
        },
        pageLayout: {
          minHeight: "unset",
          paddingBottom: 0,
          background: "transparent",
          "& .MuiContainer-root": {
            paddingTop: 0,
          },
          [theme.breakpoints.down("md")]: {
            ".Header-Container": {
              display: "none",
            },
          },
        },
        ordinalSelectSplide: {
          display: "none",
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        wrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        container: {
          position: "fixed",
          bottom: "25px",
          zIndex: theme.zIndex.modal,
          display: "flex",
          right: 0,
          left: 0,
          background: theme.palette.background.paper,
          borderRadius: "10px",
          padding: theme.spacing(2, 3),
          flexDirection: "column",
          height: 256,
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
          gap: theme.spacing(1),
          [theme.breakpoints.up("sm")]: {
            maxWidth: 565,
            margin: "auto",
          },
        },
        kioskBackButton: {
          display: "none",
        },
        title: {
          fontSize: "inherit",
          fontWeight: "bold",
        },
        primaryText: {
          color: theme.palette.text.primary,
          textAlign: "center",
          fontWeight: 600,
          lineHeight: 1.5,
        },
        highlightedText: {
          color: theme.palette.primary.main,
          textAlign: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          fontSize: "inherit",
        },
        secondaryText: {
          color: theme.palette.grey[500],
          textAlign: "center",
          lineHeight: 1.5,
          fontWeight: 600,
        },
        locationText: {
          color: theme.palette.text.primary,
          fontSize: "0.75rem",
          fontWeight: 700,
          textTransform: "uppercase",
          textAlign: "center",
          marginTop: theme.spacing(1),
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        },
        originIcon: {
          fontSize: "3.5rem",
        },
        destinationIcon: {
          fontSize: "3.5rem",
          fill: theme.palette.primary.main,
        },
        headerWrapper: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          color: theme.palette.common.black,
          fontSize: theme.typography.caption.fontSize,
          "& .MuiIconButton-root": {
            fontSize: "inherit",
          },
        },
        stepTextContainer: {
          height: "40px",
          display: "flex",
          alignItems: "center",
        },
        overviewWrapper: {
          justifyContent: "space-between",
          flexDirection: "row",
          gap: theme.spacing(1),
        },
        originIconContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "80px",
        },
        destinationIconContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "80px",
        },
        navButtonWrapper: {
          display: "none",
          flexDirection: "row",
          justifyContent: "center",
          gap: theme.spacing(4),
        },
        iconNavButton: {
          display: "block",
          padding: 0,
        },
        exitButtonWrapper: {
          position: "absolute",
          top: 0,
          right: 0,
          marginTop: theme.spacing(-6.5),
        },
        exitButton: {
          backgroundColor: theme.palette.background.default,
          border: `1px solid #ececec`,
          color: theme.palette.text.primary,
          fontWeight: 600,
          "& .MuiSvgIcon-root": {
            fill: theme.palette.primary.main,
          },
          "&:hover": {
            backgroundColor: theme.palette.grey[200],
          },
        },
        stepProgressBar: {
          display: "block",
          padding: theme.spacing(2, 3),
        },
        stepDetailStack: {
          gap: theme.spacing(1),
        },
        venueLogowrapper: {
          display: "none",
          width: "56px",
          height: "28px",
          padding: theme.spacing(0.75),
          borderRadius: "9999px",
          "& .MuiCardMedia-root": {
            width: "100%",
            height: "100%",
            backgroundSize: "contain",
          },
        },
        closeButton: {
          minWidth: "32px",
          width: "32px",
          maxWidth: "32px",
          fontSize: "0.875rem",
          color: theme.palette.text.secondary,
          border: "none",
          pointerEvents: "all",
          height: "32px",
          padding: 0,
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          background: theme.palette.grey[50],
          borderRadius: "9999px",
          right: "16px",
          top: "12px",
          "& svg": {
            width: 16,
            height: 16,
          },
          "&:hover": {
            border: "none",
            color: theme.palette.text.secondary,
            background: theme.palette.grey[50],
          },
        },
        playerWrapper: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
        playerControls: {
          display: "none",
        },
        cooldownProgress: {},
        actionButtonWrapper: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(2),
          alignItems: "center",
          justifyContent: "center",
        },
        playerButton: {
          display: "flex",
          padding: 0,
          alignItems: "center",
          justifyContent: "center",
          background: theme.palette.primary.main,
          "& .MuiSvgIcon-root": {
            fill: theme.palette.common.white,
          },
          "&:hover": {
            background: theme.palette.primary.main,
          },
        },
        pageLayout: {
          minHeight: "unset",
          paddingBottom: 0,
          background: "transparent",
        },
      },
    },
    AppFeatureDetail: {
      defaultProps: {
        operationTimeOption: {
          multiLine: false,
        },
      },
      styleOverrides: {
        root: {
          position: "relative",
          overflow: "initial",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        listContainer: {
          display: "flex",
          gap: theme.spacing(2),
          alignItems: "flex-start",
          padding: theme.spacing(1.5, 0),
        },
        featureLabel: {
          width: "auto",
          alignItems: "start",
          gap: theme.spacing(0.625),
          "& .MuiTypography-root:first-of-type": {
            textAlign: "left",
            fontWeight: 400,
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            lineHeight: 1,
          },
          "& .MuiTypography-root:last-of-type": {
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            fontWeight: 700,
            fontSize: "0.875rem",
            lineHeight: 1,
          },
        },
        operationTimeLabel: {
          flexGrow: 1,
          alignItems: "start",
          minWidth: "136px",
          gap: theme.spacing(0.625),
          "& .MuiTypography-root:first-of-type": {
            textAlign: "left",
            fontWeight: 400,
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            lineHeight: 1,
          },
          "& .MuiTypography-root:last-of-type": {
            textAlign: "left",
            fontWeight: 700,
            fontSize: "0.875rem",
            lineHeight: 1,
          },
        },
        openingLabel: {
          flexGrow: 1,
          alignItems: "start",
          gap: theme.spacing(0.625),
          "& .MuiTypography-root:first-of-type": {
            textAlign: "left",
            fontWeight: 400,
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            lineHeight: 1,
          },
          "& .MuiTypography-root:last-of-type": {
            textAlign: "left",
            fontWeight: 700,
            fontSize: "0.875rem",
            lineHeight: 1,
          },
        },
        section: {
          margin: 0,
          wordBreak: "break-word",
          "&:first-of-type": {
            marginTop: 0,
          },
        },
        galleryImage: {
          objectFit: "cover",
          display: "block",
          cursor: "pointer",
          width: "312px",
          height: "235px",
          borderRadius: "4px",
          boxShadow: "none",
        },
        divider: {
          borderBottom: `8px solid #F7F7FF`,
          marginLeft: theme.spacing(-3),
          marginRight: theme.spacing(-3),
        },
        descriptionText: {
          color: theme.palette.text.secondary,
        },
        contactButton: {
          textTransform: "lowercase",
          display: "flex",
          padding: theme.spacing(1),
          color: "#948A8D",
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: 1.1,
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.main,
          },
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(1),
          },
        },
        contactWrapper: {},
        sectionTitle: {
          display: "flex",
          fontSize: theme.typography.subtitle1.fontSize,
          fontWeight: theme.typography.fontWeightBold,
          marginBottom: theme.spacing(2),
          color: theme.palette.text.primary,
        },
        promotionHeader: {
          display: "none",
          fontSize: "1rem",
          fontWeight: 700,
        },
      },
    },
    AppImageModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
        },
        imageWrapper: {
          position: "relative",
          outline: "none",
          "& img": {
            borderRadius: "8px",
            width: "100%",
            maxHeight: "80vh",
          },
          [theme.breakpoints.up("sm")]: {
            width: "400px",
          },
        },
        closeButton: {
          color: theme.palette.common.white,
          position: "absolute",
          top: theme.spacing(-4.5),
          right: theme.spacing(-1),
          [theme.breakpoints.up("sm")]: {
            right: theme.spacing(-2),
          },
        },
      },
    },
    AppYouAreHereMarker: {
      styleOverrides: {
        root: {
          "& .primary": {
            fill: theme.palette.primary.main,
          },
          "& .primary-light": {
            fill: theme.palette.secondary.main,
          },
          "& .primary-border": {
            stroke: theme.palette.primary.main,
          },
          "& .text-primary": {
            fill: theme.palette.text.primary,
          },
          "& .secondary": {
            fill: theme.palette.secondary.main,
          },
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          fill: theme.palette.primary.main,
          width: 37,
          height: 37,
        },
        destinationIcon: {
          fill: theme.palette.error.main,
          width: 28,
          height: 47,
        },
        highlightedText: {
          color: theme.palette.primary.main,
          textAlign: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          fontSize: "inherit",
        },
      },
    },
    AppDirectionOverview: {
      defaultProps: {
        drawer: { drawerBleeding: config("device") === "mobile" ? 190 : 0 },
        maxLocationName: {
          length: 20,
        },
      },
      styleOverrides: {
        root: {},
        primaryText: {
          marginBottom: theme.spacing(1.5),
        },
        secondaryText: {
          fontWeight: 700,
        },
        drawer: {},
        bleedWrapper: {
          padding: theme.spacing(5.5, 2.75, 2.75),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2.5),
        },
        stepper: {
          "& .MuiStep-vertical": {
            ":not(:last-of-type)": {
              "& .MuiStepLabel-labelContainer": {
                borderBottom: `1px solid ${theme.palette.divider}`,
              },
            },
            "& .MuiStepLabel-labelContainer": {
              padding: theme.spacing(2.5, 0),
            },
          },
        },
        stepOverviewContainer: {
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
          "button, a": { pointerEvents: "all" },
        },
        directionSummaryContainer: {
          [theme.breakpoints.down("sm")]: {
            height: "70px",
          },
        },
        ordinalSelectMenu: {
          position: "fixed",
          bottom: "calc(190px + 16px)", // 190px (bleeding height) + 16px (spacing)
          right: theme.spacing(3),
          "& .OrdinalSelectMenu-label": {
            display: "none",
          },
        },
        locationButtonContainer: {
          display: "none",
          position: "fixed",
          bottom: "calc(192px + 24px)", // Prevent overlap with drawer (height: 190px) + 24px (spacing)
          right: theme.spacing(3),
        },
        ordinalSelector: {
          "& .OrdinalSelector-root": {
            left: "unset",
            right: theme.spacing(2),
            bottom: theme.spacing(33),
            marginRight: theme.spacing(1.5),
            padding: theme.spacing(2, 1),
          },
        },
        connector: {
          display: "none",
        },
        highlightedText: {},
        closeButton: {
          minWidth: "32px",
          width: "32px",
          maxWidth: "32px",
          fontSize: "0.875rem",
          color: theme.palette.text.secondary,
          border: "none",
          pointerEvents: "all",
          height: "32px",
          padding: 0,
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          background: theme.palette.grey[50],
          borderRadius: "9999px",
          right: "16px",
          top: "12px",
          "& svg": {
            width: 16,
            height: 16,
          },
          "&:hover": {
            border: "none",
            color: theme.palette.text.secondary,
            background: theme.palette.grey[50],
          },
        },
        locationSummaryContainer: {
          display: "flex",
          gap: theme.spacing(1),
          "&.is-long-location-name": { flexWrap: "wrap", gap: 0 },
        },
        locationContainer: {
          display: "flex",
          gap: theme.spacing(0.5),
          "&:last-of-type": {
            marginLeft: theme.spacing(0.5),
          },
        },
        locationText: {
          display: "flex",
          alignItems: "center",
          fontSize: "0.825rem",
          color: theme.palette.text.primary,
          fontWeight: 700,
        },
        startText: {
          fontSize: "0.825rem",
          color: "#666471",
          display: "flex",
          alignItems: "center",
        },
        endText: {
          fontSize: "0.825rem",
          color: "#666471",
          display: "flex",
          alignItems: "center",
        },
        venueLogoContainer: {
          display: "none",
          width: "38px",
          height: "24px",
          padding: theme.spacing(0.75),
          borderRadius: "9999px",
        },
        venueLogo: { width: "100%", height: "100%", backgroundSize: "contain" },
        pageLayout: {
          minHeight: "unset",
          paddingBottom: 0,
          background: "transparent",
        },
      },
    },
    DirectionCardActions: {
      styleOverrides: {
        root: {
          height: "auto",
          padding: 0,
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
        },
        actionButton: {
          [theme.breakpoints.down("sm")]: {
            fontWeight: 700,
            "& .MuiButton-startIcon": {
              marginRight: theme.spacing(1.25),
            },
          },
        },
      },
    },
    HomePage: {
      defaultProps: {
        variant: null, // null (uses legacy disign), standardV1 (uses new design)
      },
      styleOverrides: {
        root: {},
        contentContainer: {
          display: "flex",
          flexDirection: "column",
        },
        welcomePanelWrapper: {},
        featureCarouselWrapper: {
          padding: theme.spacing(3, 3, 12, 3),
        },
        textCard: {
          borderRadius: "15px",
          height: 136,
          display: "flex",
          alignItems: "center",
          p: theme.spacing(1),
          justifyContent: "center",
          flex: 1,
          [theme.breakpoints.up("md")]: {
            height: "100%",
          },
        },
        linkCardContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 1.25,
          "&>*": {
            flex: 1,
            height: "100%",
          },
          [theme.breakpoints.up("md")]: {
            height: "300px",
          },
        },
        defaultCardIcon: {
          color: theme.palette.primary.main,
          display: "flex",
          justifyContent: "center",
        },
        defaultCardTextContainer: {
          gap: theme.spacing(0.5),
        },
        defaultCardPrimaryText: {
          textAlign: "center",
          fontSize: "14px",
          lineHeight: 1.4,
        },
        defaultCardSecondaryText: {
          color: theme.palette.text.secondary,
          textAlign: "center",
          fontSize: "12px",
          lineHeight: 1.4,
        },
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        carousel: {},
        carouselItem: {
          [theme.breakpoints.up("md")]: {
            width: "230px",
          },
        },
      },
    },
    FullScreenStart: {
      styleOverrides: {
        root: {
          cursor: "pointer",
          zIndex: -1,
          background: `linear-gradient(0deg, ${alpha(
            theme.palette.common.black,
            0.4
          )} 0%, ${alpha(theme.palette.common.black, 0.4)} 100%)`,
        },
        actionButtonWrapper: {
          position: "relative",
          display: "inline-block",
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `5px solid ${alpha(theme.palette.common.white, 0.4)}`,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut}`,
          },
          "&:before": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut} 0.5s`,
          },
        },
        actionButton: {
          position: "relative",
          fontSize: "1rem",
          textTransform: "uppercase",
          color: theme.palette.text.secondary,
          fontWeight: 700,
          borderRadius: 999,
          backgroundColor: theme.palette.common.white,
          transition: theme.transitions.create("all"),
          boxShadow: theme.shadows[10],
          padding: theme.spacing(1.25, 3),
          "&:hover": {
            boxShadow: theme.shadows[20],
            backgroundColor: theme.palette.common.white,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
          },
          "& .MuiButton-startIcon>svg": {
            fontSize: "1.5rem",
            color: theme.palette.primary.main,
          },
          [theme.breakpoints.up("md")]: {
            transform: "scale(1.2)",
          },
        },
        actionButtonTextWrapper: {},
        actionButtonTextPrimary: {},
        actionButtonTextSecondary: {},
      },
    },
    DirectoryPage: {
      styleOverrides: {
        root: {
          "& .MuiList-root": {},
          "& .level-filterbar": {
            display: "none",
          },
        },
        filterSection: {
          position: "sticky",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          top: 0,
          zIndex: 1,
          marginTop: 0,
          paddingTop: theme.spacing(3),
          background: theme.palette.background.paper,
        },
        categoryFilterBar: {
          gap: theme.spacing(2),
          padding: 0,
          "& .MuiToggleButton-root": {
            ":first-of-type": {
              marginLeft: theme.spacing(3),
              [theme.breakpoints.up("md")]: {
                marginLeft: theme.spacing(6),
              },
            },
            ":last-of-type": {
              marginRight: theme.spacing(3),
              [theme.breakpoints.up("md")]: {
                marginRight: theme.spacing(6),
              },
            },
            "& .MuiTypography-root": {
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              overflow: "hidden",
            },
          },
        },
        subCategoryFilterBar: {
          gap: theme.spacing(2),
          padding: 0,
          "& .MuiToggleButton-root": {
            borderRadius: "9999px",
            padding: theme.spacing(1.5),
            height: "unset",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:first-of-type": {
            borderRadius: "9999px",
            marginLeft: theme.spacing(3),
            [theme.breakpoints.up("md")]: {
              marginLeft: theme.spacing(6),
            },
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:last-of-type": {
            marginRight: theme.spacing(3),
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:not(:first-of-type)":
            {
              borderRadius: "9999px",
            },
        },
        levelFilterBar: {},
        scrollPane: {
          padding: 0,
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
          },
          "& .MuiDivider-root": {
            borderBottomWidth: 8,
          },
        },
        buildingWithLevelFilterSection: {
          display: "none",
          gap: theme.spacing(2),
          padding: theme.spacing(0, 3),
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
          },
          "& .MuiDivider-root": {
            borderBottomWidth: 8,
          },
        },
        buildingFilterSelect: {
          flex: "5 0 0",
        },
        levelFilterSelect: {
          flex: "4 0 0",
        },
        selectMenuItem: {
          fontSize: "0.75rem",
        },
        resetButton: {
          color: theme.palette.info.main,
          textDecoration: "underline",
          fontSize: "0.75rem",
        },
        divider: {
          borderBottomWidth: "0.5px",
          background: theme.palette.grey[500],
        },
        list: {
          padding: theme.spacing(0, 1),
          paddingTop: theme.spacing(1),
          paddingBottom: `${(mixins.bottomNavigation?.height || 75) + 30}px`,
        },
        emptyDataWrapper: {
          marginTop: theme.spacing(3),
        },
        venueSelector: {
          display: "block",
          position: "fixed",
          bottom: mixins.bottomNavigation?.height + 45,
          right: "24px",
          [theme.breakpoints.down("md")]: {
            display: "none",
          },
        },
        pageLayout: {},
        levelHeader: {
          display: "flex",
          gap: theme.spacing(3),
          position: "sticky",
          top: 154,
          background: theme.palette.background.default,
          zIndex: 2,
          fontWeight: 700,
          fontSize: "1rem",
          padding: theme.spacing(2, 1.5),
          "&.with-sub-category": {},
        },
        headerDivider: {
          flex: 1,
          alignSelf: "center",
          borderColor: theme.palette.divider,
          borderWidth: "1px",
        },
      },
    },
    LevelFilterBar: {
      styleOverrides: {
        root: {
          padding: 0,
          "& .MuiToggleButton-root": {
            padding: theme.spacing(1, 3),
            flexShrink: 0,
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(3),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(3),
          },
        },
      },
    },
    DirectoryOccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          display: "flex",
          height: "80px",
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
        },
        occupantLogo: {
          boxShadow: theme.shadows[1],
          minWidth: "80px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(1, 1.4),
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
      },
    },
    PromotionPage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gridAutoFlow: "row",
          justifyItems: "center",
          gap: theme.spacing(1.5),
          "&>*": {
            width: "100%",
          },
        },
        promotionCard: {},
        emptyDataWrapper: {
          paddingTop: "40%",
          paddingBottom: 0,
        },
        promotionGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          marginBottom: theme.spacing(1.5),
        },
        toggleButtonGroup: {
          background: "#E4E2E3",
          padding: theme.spacing(0.5),
          borderRadius: "9999px",
          width: "344px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "9999px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "9999px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "9999px",
            fontSize: "1rem",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
            flex: 1,
            color: theme.palette.text.primary,
            height: "38px",
            "&.Mui-selected": {
              fontWeight: 700,
              color: theme.palette.primary.contrastText,
            },
          },
        },
      },
    },
    FeatureActionContainer: {
      styleOverrides: {
        shortInfoActionWrapper: {
          gridArea: "button",
          flexDirection: "column",
          gap: theme.spacing(1),
          justifySelf: "self-end",
          "&>:not(style)+:not(style)": {
            marginLeft: 0,
          },
          "@media (min-width: 768px)": {
            paddingTop: 0,
            flexDirection: "row",
            justifySelf: "unset",
            paddingLeft: 0,
            paddingBottom: theme.spacing(1.5),
          },
        },
        navigationButton: {
          maxWidth: "142px",
          fontSize: "1rem",
          pointerEvents: "all",
          "@media (max-width:385px)": {
            fontSize: "1rem",
          },
          height: "38px",
          padding: theme.spacing(1),
          justifyContent: "flex-start",
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(0.5),
          },
        },
        actionButton: {
          maxWidth: "134px",
          fontSize: "1rem",
          color: "#56464A",
          border: "1px solid #E4E2E3",
          pointerEvents: "all",
          "@media (max-width:385px)": {
            fontSize: "1rem",
          },
          height: "38px",
          padding: theme.spacing(1),
          justifyContent: "flex-start",
        },
        comingSoonButton: {
          padding: theme.spacing(1),
          fontSize: "1rem",
          height: "38px",
        },
        backButton: {
          display: "none",
          minWidth: "32px",
          width: "32px",
          maxWidth: "32px",
          fontSize: "0.875rem",
          color: theme.palette.text.secondary,
          border: "none",
          pointerEvents: "all",
          height: "32px",
          padding: 0,
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          background: theme.palette.grey[50],
          borderRadius: "9999px",
          right: "16px",
          top: "12px",
          "& svg": {
            width: 16,
            height: 16,
          },
          "&:hover": {
            border: "none",
            color: theme.palette.text.secondary,
            background: theme.palette.grey[50],
          },
        },
      },
    },
    AppDesktopFeatureDialog: {
      styleOverrides: {
        dialog: {
          height: "100%",
          maxWidth: "50vw",
          left: "unset",
          "& .MuiDialog-container": {
            justifyContent: "flex-end",
          },
        },
        contentContainer: {
          padding: theme.spacing(3),
          background: theme.palette.common.white,
          boxShadow: "none",
          "& .FeatureSummary-root": {},
          "& .FeatureDetail-root": {},
          "& .FeatureDetail-section": {
            "&:first-of-type": {
              marginTop: theme.spacing(3),
            },
          },
        },
      },
    },
    EventPage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gridAutoFlow: "row",
          justifyItems: "center",
          gap: theme.spacing(1.5),
          "&>*": {
            width: "100%",
          },
        },
        emptyDataWrapper: {
          paddingTop: "40%",
          paddingBottom: 0,
        },
        eventGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          marginBottom: theme.spacing(1.5),
        },
        toggleButtonGroup: {
          background: "#E4E2E3",
          padding: theme.spacing(0.5),
          borderRadius: "9999px",
          width: "344px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "9999px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "9999px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "9999px",
            fontSize: "1rem",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
            flex: 1,
            color: theme.palette.text.primary,
            height: "38px",
            "&.Mui-selected": {
              fontWeight: 700,
              color: theme.palette.primary.contrastText,
            },
          },
        },
      },
    },
    VerticalEventCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "12px",
          padding: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: "302px",
          border: "1px solid #E2E2E4",
          "&.MuiCardContent-dense": {
            "& .MuiCardContent-root ": { padding: theme.spacing(2) },
          },
        },
        cardMedia: {
          width: "100%",
          height: "207px",
          borderRadius: "none",
          objectFit: "cover",
          position: "relative",
        },
        cardContent: {
          height: "95px",
          padding: theme.spacing(0.5, 1.5),
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:last-child": {
            paddingBottom: theme.spacing(0.5),
          },
          [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(0.5, 1.5),
          },
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          fontSize: "0.875rem",
          fontWeight: 700,
          lineHeight: 1,
          wordBreak: "break-word",
        },
        iconContainer: {
          display: "flex",
          alignItems: "center",
          width: "auto",
          "& .MuiSvgIcon-root": {
            position: "relative",
            top: "-2px",
            width: "12px",
            height: "12px",
          },
        },
        cardInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          fontSize: "0.75rem",
          gap: theme.spacing(0.5),
          "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            fontSize: "0.75rem",
            WebkitLineClamp: 1,
          },
        },
        venueLogoContainer: {
          display: "none",
          "& .MuiCardMedia-root": {
            maxWidth: "120px",
          },
        },
        cardContentStack: {
          gap: theme.spacing(1),
        },
        durationContainer: {
          color: theme.palette.text.secondary,
          borderRadius: "80px",
          width: "fit-content",
        },
        duration: {
          fontSize: "0.75rem",
        },
        recommendText: {
          width: "100%",
          backgroundColor: theme.palette.primary.main,
          position: "absolute",
          bottom: "-1px",
          left: 0,
          borderRadius: "4px 4px 0px 0px",
          textAlign: "center",
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {},
        topChipWrapper: { display: "none" },
        bottomChipWrapper: { display: "none" },
        recommendTextContainer: {},
        statusTextContainer: {},
      },
    },
    ImageCard: {
      styleOverrides: {
        root: {},
        chipContainer: {
          position: "absolute",
          padding: "3%",
          right: 0,
          top: 0,
          zIndex: 1,
        },
        chip: {
          backgroundColor: theme.palette.error.main,
          borderRadius: "10px",
          color: theme.palette.error.contrastText,
        },
      },
    },
    ImageSkeletonCard: {
      styleOverrides: {
        root: {
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
        },
      },
    },
    PromotionCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "12px",
          padding: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: "302px",
          border: "1px solid #E2E2E4",
          "&.MuiCardContent-dense": {
            "& .MuiCardContent-root ": { padding: theme.spacing(2) },
          },
        },
        cardMedia: {
          width: "100%",
          height: "207px",
          borderRadius: "none",
          objectFit: "cover",
          position: "relative",
        },
        cardContent: {
          height: "95px",
          padding: theme.spacing(0.5, 1.5),
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:last-child": {
            paddingBottom: theme.spacing(0.5),
          },
          [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(0.5, 1.5),
          },
        },
        venueLogoContainer: {
          display: "none",
          "& .MuiCardMedia-root": {
            maxWidth: "120px",
          },
        },
        venueLogo: {},
        cardContentStack: {
          gap: theme.spacing(1),
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          fontSize: "0.875rem",
          fontWeight: 700,
          lineHeight: 1,
          wordBreak: "break-word",
        },
        cardInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          fontSize: "0.75rem",
          gap: theme.spacing(0.5),
          "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            fontSize: "0.75rem",
            WebkitLineClamp: 1,
          },
        },
        durationContainer: {
          color: theme.palette.text.secondary,
          borderRadius: "80px",
          width: "fit-content",
        },
        duration: {
          fontSize: "0.75rem",
        },
        iconContainer: {
          display: "flex",
          alignItems: "center",
          width: "auto",
          "& .MuiSvgIcon-root": {
            position: "relative",
            top: "-2px",
            width: "12px",
            height: "12px",
          },
        },
        recommendText: {
          width: "100%",
          backgroundColor: theme.palette.primary.main,
          position: "absolute",
          bottom: "-1px",
          left: 0,
          borderRadius: "4px 4px 0px 0px",
          textAlign: "center",
          color: theme.palette.primary.contrastText,
        },
        chipContainer: { display: "none" },
        recommendTextContainer: {},
        cardContentSecondaryText: {
          wordBreak: "break-word",
        },
        topChipWrapper: { display: "none" },
        bottomChipWrapper: { display: "none" },
      },
    },
    HighlightFeatureCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          display: "flex",
          flexDirection: "row",
          height: 136,
          padding: theme.spacing(1.5, 1.375),
          [theme.breakpoints.up("md")]: {
            width: "100%",
            height: "100%",
          },
        },
        cardMedia: {
          width: 74,
          maxHeight: 164,
          borderRadius: "5px",
          objectFit: "cover",
          [theme.breakpoints.up("md")]: {
            width: 230,
            height: 300,
            maxHeight: "unset",
          },
        },
        cardContent: {
          padding: theme.spacing(1.375, 0, 1.375, 3),
          "&:last-child": {
            paddingBottom: theme.spacing(1),
            [theme.breakpoints.up("sm")]: {
              padding: theme.spacing(1, 1, 1, 3),
            },
          },
        },
        contentWrapper: {
          height: "100%",
          justifyContent: "space-between",
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        cardInfoWrapper: {
          gap: theme.spacing(0.5),
        },
        cardInfoItem: {
          display: "flex",
          color: theme.palette.text.secondary,
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: 16,
          height: 16,
          display: "flex",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: "100%",
            width: "100%",
            color: theme.palette.primary.main,
          },
        },
      },
    },
    ListPromotionItemCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          display: "flex",
          flexDirection: "row",
          height: 104,
          padding: theme.spacing(1, 0.5),
        },
        cardMedia: {
          width: 88,
          maxHeight: 88,
          borderRadius: "5px",
          objectFit: "cover",
          [theme.breakpoints.up("sm")]: {
            width: 95,
          },
        },
        cardContent: {
          padding: theme.spacing(0.5, 1, 0.5, 2),
          "&:last-child": {
            paddingBottom: theme.spacing(0.5),
            [theme.breakpoints.up("sm")]: {
              padding: theme.spacing(0.5, 1, 0.5, 2),
            },
          },
        },
        contentWrapper: {
          height: "100%",
          gap: theme.spacing(2),
          justifyContent: "space-between",
        },
        cardTitle: {
          fontWeight: 600,
          fontSize: "14px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        promotionInfoItem: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: 16,
            color: "inherit",
          },
        },
      },
    },
    ServicePage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateColumns: "repeat(1, 1fr)",
          justifyItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1),
        },
        gridItem: {
          width: "100%",
        },
        emptyDataContainer: {
          display: "flex",
          paddingTop: "60%",
          justifyContent: "center",
          alignItems: "center",
        },
        headerWrapper: {},
        navigationWrapper: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "8px",
          overflow: "hidden",
          border: "0.4px solid #E2E2E4",
          "&:first-of-type": {
            borderRadius: "8px",
          },
          "&:last-of-type": {
            borderRadius: "8px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "92px",
          padding: theme.spacing(1.5),
          gap: theme.spacing(1),
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 0,
            background: `linear-gradient(89deg, ${alpha(
              theme.palette.background.paper,
              0.9
            )} 49.87%, ${alpha(theme.palette.background.paper, 0)} 92.75%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: "#494656",
            "& .MuiSvgIcon-root": {
              width: "24px",
              height: "24px",
            },
          },
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.5),
          alignItems: "center",
          zIndex: 1,
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "48px",
          height: "48px",
          background: "#ECECED",
        },
        serviceIcon: {
          color: "#948A8D",
          width: "24px",
          height: "24px",
        },
        infoContainer: {},
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "1rem",
          fontWeight: 700,
          color: theme.palette.text.primary,
          lineHeight: 1.1,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          color: "#948A8D",
          fontSize: "0.875rem",
          lineHeight: 1.1,
          marginTop: theme.spacing(1),
        },
        accordionDetails: {
          padding: theme.spacing(1, 1.5),
          backgroundColor: "#fff",
        },
        locationList: {
          overflow: "hidden auto",
          maxHeight: "200px",
          "::-webkit-scrollbar": {
            width: "4px",
          },
          "::-webkit-scrollbar-track": {
            background: "#C7C6C6",
          },
          "::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
          },
        },
        locationListItem: {
          height: 40,
          borderBottom: "solid 1px #E2E2E4",
          padding: theme.spacing(1, 0),
          "&:last-of-type": {
            borderBottom: "none",
          },
        },
        locationNavigateButton: {
          color: "#494656",
          marginRight: theme.spacing(-3),
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        venueLogoWrapper: {
          width: 92,
          height: 32,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        venueLogo: {
          maxHeight: 30,
          maxWidth: 60,
          objectFit: "contain",
        },
        divider: {
          borderColor: "#E2E2E4",
        },
        floorTextAvatar: {
          width: 32,
          height: 32,
          color: theme.palette.text.secondary,
          minWidth: 32,
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1rem",
          display: "flex",
          marginLeft: theme.spacing(2),
          lineHeight: 1.1,
          marginRight: theme.spacing(3),
        },
        listNameText: {
          fontSize: "1rem",
          lineHeight: 1.1,
          color: theme.palette.text.secondary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
          marginRight: theme.spacing(3),
        },
        serviceLabel: {
          fontSize: "1rem",
          lineHeight: 1.1,
          color: theme.palette.text.secondary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
          flex: 1,
          marginLeft: theme.spacing(0.5),
        },
      },
    },
    ListPrivilegeItemCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: "8px",
          padding: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            color: theme.palette.grey[500],
            width: 16,
            height: 16,
          },
        },
        label: {
          color: theme.palette.text.secondary,
          fontWeight: 600,
        },
      },
    },
    FeatureSummary: {
      styleOverrides: {
        root: {
          display: "grid",
          gridTemplateRows: "1fr 142px",
          gridTemplateColumns: "192px minmax(0, 146px)",
          gridGap: 0,
          gridTemplateAreas: `
                  "info info"
                  "logo button"
                `,
          "@media (min-width: 768px)": {
            gridTemplateRows: "1fr 84px 50px",
            gridTemplateColumns: "1fr",
            gridTemplateAreas: "'info' \n 'logo' \n 'button'",
          },
        },
        infoSection: {
          gridArea: "info",
          display: "flex",
          flexDirection: "row",
          minHeight: "56px",
          alignItems: "flex-start",
          gap: theme.spacing(1.5),
        },
        maintenanceAlert: {
          width: "145px",
          height: "36px",
          backgroundColor: "transparent",
          padding: 0,
          "& .MuiAlert-message": {
            padding: 0,
          },
          "& .MuiChip-root": {
            height: "36px",
            width: "145px",
          },
        },
        title: {
          fontSize: "1.5rem",
          lineHeight: 1.1,
        },
        container: {
          gridArea: "logo",
          gap: theme.spacing(3),
          display: "flex",
          boxShadow: "none",
        },
        infoContainer: {},
        logoContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 84,
          height: 84,
          borderRadius: "7.5px",
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        },
        logoImage: {
          borderRadius: "8px",
        },
        venueLogoContainer: {
          width: 84,
          height: 84,
          borderRadius: 0,
          alignItems: "center",
          padding: theme.spacing(0.5),
        },
        venueLogoImage: {
          width: "100%",
          height: "100%",
          objectFit: "contain",
        },
        locationText: {},
        categoryIcon: {
          width: "36px",
          height: "36px",
        },
        statusTagContainer: {
          display: "none",
        },
        newShopChip: {},
        comingSoonChip: {},
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "subtitle1" },
          style: {
            lineHeight: 1.4,
          },
        },
      ],
    },
    DirectionStepItem: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(2.5),
          },
          "&:first-of-type": {
            "& .MuiListItemText-primary": {
              fontWeight: 700,
            },
          },
          "&:last-of-type": {
            "& .MuiListItemText-primary": {
              fontWeight: 600,
            },
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: theme.spacing(0.5),
              paddingRight: theme.spacing(3),
            },
          },

          "& .MuiStepIcon-root": {
            width: 37,
            height: 37,
            "& .MuiStepIcon-text": {
              fontSize: theme.typography.caption.fontSize,
            },
          },
          "& .MuiStepLabel-vertical": {
            padding: 0,
          },
        },
        listItem: {
          "& .MuiListItemText-primary": {
            whiteSpace: "normal",
            color: theme.palette.text.primary,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.subtitle2.fontWeight,
          },
          "& .MuiListItemText-secondary": {
            fontSize: "0.75rem",
          },
          "& .MuiListItemSecondaryAction-root": {
            marginLeft: "auto",
            position: "static",
            transform: "none",
            color: theme.palette.text.secondary,
            right: 0,
          },
        },
        listItemIcon: {
          display: "none",
        },
      },
    },
    EmptyData: {
      styleOverrides: {
        root: {
          width: "100%",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "80px",
            height: "80px",
            color: theme.palette.grey[200],
          },
        },
        secondaryText: {
          color: theme.palette.grey[600],
        },
        iconWrapper: {
          marginBottom: theme.spacing(1),
        },
      },
    },
    NewShopsPage: {
      styleOverrides: {
        emptyDataContainer: {
          height: `calc(100vh - ${mixins.mobileHeader?.height}px - ${
            mixins.bottomNavigation?.height + 30
          }px - 72px)`,
          // Prevent content page overlap with footer shadow by adding a bottom space (30px)
          //72 px is container padding
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        newShopImageCard: {
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
          "& .MuiCardActionArea-root": {
            width: "100%",
            height: "100%",
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "100%",
          },
          "& .MuiCardHeader-root": {
            paddingBottom: theme.spacing(1),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
          },
          "& .MuiCardHeader-subheader": {
            "& .sub-category-text": {
              display: "none",
            },
            "& .booth-name-text": {
              display: "none",
            },
          },
          "& .MuiChip-root": {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
          },
          "& .MuiCardHeader-root .MuiCardHeader-avatar": {
            marginRight: theme.spacing(1),
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "50px",
            height: "50px",
          },
        },
        newShopAvatarFallBack: {},
        newShopFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.common.white,
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        newShopFallbackImageIcon: {
          height: "48px",
          width: "48px",
          zIndex: 1,
        },
        comingSoonShopImageCard: {
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
          "& .MuiCardActionArea-root": {
            width: "100%",
            height: "100%",
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "100%",
          },
          "& .MuiCardHeader-root": {
            paddingBottom: theme.spacing(1),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
          },
          "& .MuiCardHeader-subheader": {
            "& .sub-category-text": {
              display: "none",
            },
            "& .booth-name-text": {
              display: "none",
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
            },
          },
          "& .MuiChip-root": {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.grey[500],
          },
          "& .MuiCardHeader-root .MuiCardHeader-avatar": {
            marginRight: theme.spacing(1),
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "50px",
            height: "50px",
          },
        },
        comingSoonShopAvatarFallBack: {},
        comingSoonShopFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.grey[400],
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        comingSoonShopFallbackImageIcon: {
          height: "48px",
          width: "48px",
          zIndex: 1,
        },
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1),
        },
        venueSelector: {
          position: "fixed",
          bottom: mixins.bottomNavigation?.height + 45,
          right: "24px",
          zIndex: 1,
        },
        pageLayout: {},
      },
    },
    OccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: "10px",
          width: "100%",
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        cardMediaWrapper: {
          position: "relative",
        },
        cardMedia: {
          height: "180px",
        },
        cardContent: {
          padding: theme.spacing(1.5, 2),
          "&:last-child": {
            paddingBottom: theme.spacing(1),
          },
        },
      },
    },
    UserLocationListItem: {
      styleOverrides: {
        icon: {
          background: "transparent",
          color: theme.palette.text.primary,
          fontSize: "3rem",
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
      },
    },
    FeatureListItem: {
      defaultProps: {
        boothNameTextSeparator: " | ",
        locationTextSeparator: " | ",
        showStatusChip: false,
      },
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
        adornmentWrapper: {
          display: "none",
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          width: "fit-content",
        },
        adornmentMedia: {
          objectFit: "contain",
          maxWidth: "60px",
          maxHeight: "55px",
        },
        adornmentDivider: {
          marginRight: theme.spacing(1),
          borderRight: "1px solid rgba(203, 203, 203, 0.5)",
        },
        adornmentTextAvatar: {
          width: 24,
          height: 24,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          minWidth: 24,
          borderRadius: "50%",
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.75rem",
        },
        bottomDivider: {
          borderBottom: "1px solid rgba(203, 203, 203, 0.5)",
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
        listItemText: {
          flex: 2.5,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
          "& .MuiListItemText-primary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.2,
            fontSize: "1rem",
            fontWeight: 700,
            whiteSpace: "normal",
            wordBreak: "break-word",
          },
          "& .MuiListItemText-secondary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.4,
            whiteSpace: "normal",
            wordBreak: "break-all",
          },
          "& span": {
            color: theme.palette.text.secondary,
            fontSize: "0.875rem",
          },
        },
        listItemAvatar: {
          "& .MuiAvatar-root": {
            fontSize: "2.275rem",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
          "& .MuiAvatar-root .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        listItemContent: {
          display: "flex",
          width: "100%",
          gap: theme.spacing(2),
        },
        boothNameText: {
          display: "none",
        },
        venueText: {
          display: "none",
        },
        locationText: {},
        categoryText: {},
        maintenanceIcon: {
          // TODO:: Remove `display: none` when standard maintenance design is available.
          display: "none",
          position: "relative",
          bottom: theme.spacing(-0.5),
          width: "18px",
          height: "18px",
          marginRight: theme.spacing(0.5),
        },
        sponsoredChip: {
          display: "none",
          alignItems: "center",
          width: "fit-content",
          height: "20px",
          backgroundColor: theme.palette.grey[200],
          color: "#8C8A94",
          fontSize: "0.75rem",
          fontWeight: 400,
          padding: theme.spacing(0.5, 1),
          marginRight: "4px",
          "& .MuiChip-label": {
            lineHeight: "normal",
            padding: 0,
          },
          listItemWrapper: {
            gap: 0,
          },
        },
        listItemWrapper: {
          display: "flex",
          gap: theme.spacing(0.5),
          flexDirection: "column",
          flexGrow: 1,
        },
      },
    },
    FeatureSkeletonListItem: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
        bottomDivider: {
          height: "1px",
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
        listItemTextPrimary: {
          fontSize: "1rem",
        },
        listItemTextSecondary: {
          fontSize: "0.875rem",
        },
        listItemAvatar: {},
        avatar: {
          width: 55,
          height: 55,
          marginRight: theme.spacing(2.25),
        },
        listItemContent: {
          flex: 2.5,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
        },
      },
    },
    DirectionSearchContainer: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
          },
        },
        suggestionList: {
          marginTop: theme.spacing(8),
          // direction search box = 108 px
          // avoid step button 32 px + top-bottom margin 16px * 2 = 64px
          // top-bottom page layout padding 24px * 2 = 48px
          maxHeight: `calc(100vh - 220px)`,
          overflow: "auto",
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          position: "absolute",
          zIndex: theme.zIndex.drawer + 1,
          borderRadius: "10px",
          //left-right layout padding = 24 * 2 = 48px
          width: `calc(100vw - 48px)`,
          [theme.breakpoints.up("sm")]: {
            //left-right layout padding = 24 * 2 = 48px
            maxWidth: mixins.mobileDirectionSearch.width - 48,
          },
        },
      },
    },
    AppOrdinalSelector: {
      styleOverrides: {
        root: {
          position: "fixed",
          bottom: theme.spacing(27),
          left: theme.spacing(2),
          borderRadius: 9999,
          backgroundColor: theme.palette.background.default,
          boxShadow: theme.shadows[15],
          width: "48px",
          padding: theme.spacing(0.25),
        },
        listItemButton: {
          justifyContent: "center",
          borderRadius: 9999,
          backgroundColor: theme.palette.background.default,
          fontSize: "0.875rem",
          fontWeight: theme.typography.fontWeightRegular,
          transition: `color ${theme.transitions.duration.short}ms ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} , background-color ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
          minHeight: "44px",
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        ordinalSelectorTitle: {
          display: "none",
        },
        ordinalList: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(0.5),
          padding: 0,
        },
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          gap: theme.spacing(2),
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          transition: `transform ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
          "&.all": { display: "none" },
          "&.selected": {
            transform: "scale(1.77)",
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
          },
        },
        button: {
          padding: 0,
          backgroundColor: theme.palette.primary.main,
          width: "47px",
          height: "47px",
          borderRadius: "50%",
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            ":hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        allVenueIcon: {
          width: "100%",
          height: "100%",
        },
        icon: {
          width: "100%",
          height: "100%",
        },
        currentVenueChip: {
          position: "absolute",
          height: "8px",
          width: "32px",
          bottom: "-4px",
        },
        allVenueLabel: {
          display: "none",
        },
      },
    },
    LanguageButton: {
      defaultProps: {},
      styleOverrides: {
        root: {
          width: "40px",
          height: "40px",
          padding: "12px",
          gap: theme.spacing(1),
          borderRadius: "9999px",
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.common.white,
          "&.MuiButtonBase-root": {
            "&:hover": {
              backgroundColor: "#fff",
            },
          },
          "& .MuiButton-endIcon": {
            marginLeft: 0,
            "& .MuiSvgIcon-root": {
              width: "20px",
              height: "20px",
              color: "#C6C5C9",
            },
          },
          "&.is-expanded": {
            "& .MuiButton-endIcon": {
              "& .MuiSvgIcon-root": {
                transform: "rotate(180deg)",
              },
            },
          },
        },
        baseRoot: {},
        expandIcon: {},
        avatar: {
          display: "none",
        },
        label: {
          fontWeight: 400,
          fontSize: theme.spacing(1.5),
          display: "inline-flex",
          color: "#8C8A94",
        },
        menuPaper: {
          minWidth: "80px",
          "&:after": {
            display: "none",
          },
        },
        menuItem: {
          fontSize: theme.spacing(1.5),
        },
        secondaryLabel: { display: "none" },
      },
    },
    OrdinalSelectMenu: {
      defaultProps: {
        anchorOrigin: { vertical: "top", horizontal: "center" },
        transformOrigin: { vertical: "bottom", horizontal: "center" },
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.primary.main,
          width: "100px",
          height: "40px",
          padding: theme.spacing(1, 2),
          marginTop: theme.spacing(0.75),
          borderRadius: "50px",
          textAlign: "center",
          "&.Mui-focused": {
            border: "none",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "& svg": {
              color: theme.palette.primary.contrastText,
            },
          },
          "& .MuiSelect-select.MuiOutlinedInput-input": {
            fontSize: "0.875rem",
            textAlign: "left",
            color: theme.palette.primary.contrastText,
            padding: "0px",
          },
          "& .MuiSelect-select.MuiInputBase-input": {},
          "& .MuiSelect-icon": {
            right: theme.spacing(1.25),
            color: theme.palette.primary.contrastText,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
          },
        },
        paper: {
          backgroundColor: "transparent",
          boxShadow: "none",
          alignItems: "center",
          maxHeight: "35vh",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        menuList: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        },
        menuItem: {
          margin: theme.spacing(1),
          backgroundColor: theme.palette.background.paper,
          borderRadius: "50%",
          width: "56px",
          height: "56px",
          padding: 0,
          minHeight: "56px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transformOrigin: "top center",
          animation: `slideUp 300ms ease-in-out forwards`,
          "&.Mui-selected": {
            border: `1px solid ${theme.palette.primary.contrastText} `,
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            ":hover,:focus": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          ":hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
        text: {
          textTransform: "uppercase",
          fontSize: "0.875rem",
          textAlign: "center",
          color: theme.palette.text.secondary,
        },
      },
    },
    BorderLinearProgress: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "100%",
          "&:after": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            content: "''",
            display: "block",
            height: 4,
            width: "100%",
            borderRadius: 5,
            backgroundColor: theme.palette.grey[300],
            right: 0,
          },
        },
        linearProgress: {
          height: 20,
          borderRadius: 15,
          zIndex: 1,
          ":after": {
            position: "absolute",
            zIndex: 5,
            top: "50%",
            transform: "translateY(-50%)",
            height: 4,
            content: "''",
            display: "block",
          },
          "&.MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            "&.Mui-start": {
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":after": {
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              content: "''",
              display: "inline-block",
              width: 14,
              height: 14,
              borderRadius: "50%",
              backgroundColor: theme.palette.grey[300],
              zIndex: 1,
              left: 0,
            },
            "&.Mui-complete": {
              ":before": {
                backgroundColor: theme.palette.primary.main,
              },
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":before": {
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              content: "''",
              display: "inline-block",
              width: 14,
              height: 14,
              borderRadius: "50%",
              backgroundColor: theme.palette.grey[300],
              zIndex: 1,
              right: 0,
            },
          },
          "& .MuiLinearProgress-bar": {
            margin: "auto 0",
            height: 4,
            borderRadius: 5,
            backgroundColor: theme.palette.primary.main,
            boxShadow: `0px 0px 10px ${theme.palette.primary.main}`,
          },
        },
      },
    },
    StepProgressBar: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          overflowX: "scroll",
          padding: theme.spacing(1),
          marginTop: 0,
          scrollbarWidth: "none", // Hide the scrollbar for firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
          },
          "&-ms-overflow-style:": {
            display: "none", // Hide the scrollbar for IE
          },
        },
        stepper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
          zIndex: 2,
          "& .MuiStepLabel-iconContainer": {
            padding: 0,
          },
        },
        originIcon: {
          "&.MuiSvgIcon-root": {
            height: "28px",
            width: "28px",
            fill: theme.palette.primary.main,
          },
        },
        connector: {
          "& .MuiStepConnector-line": {
            margin: theme.spacing(0, -1),
            height: 3,
            border: 0,
            minWidth: 36,
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
      },
    },
    CategoryQuickSearch: {
      styleOverrides: {
        categoryFilterBarContainer: {
          order: 2,
          width: "100vw",
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(2.5, 0, 0, 0),
          display: "none",
        },
        scrollPane: {},
        categoryFilterBar: {
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            display: "none",
          },
          "& .highlight .MuiSvgIcon-root": {
            display: "block",
            margin: 0,
          },
        },
      },
    },
    VuiSearchBasePopup: {
      styleOverrides: {
        drawerPaper: {},
      },
    },
    VuiSearchPopupContent: {
      styleOverrides: {
        root: {
          order: 1,
        },
      },
    },
    VuiSearchResult: {
      styleOverrides: {
        root: {
          order: 3,
        },
      },
    },
    MapUpdateLoadingScreen: {
      styleOverrides: {
        backdrop: {
          zIndex: theme.zIndex.modal,
        },
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
          color: theme.palette.primary.main,
        },
      },
    },
    SuggestionListItem: {
      defaultProps: {},
      styleOverrides: {
        root: {},
      },
    },
    VerticalDirectionImageDialog: {
      styleOverrides: {
        root: {
          overflow: "hidden",
          zIndex: 1,
          "& .MuiPaper-elevation": {
            maxWidth: "240px",
            width: "240px",
            height: "104px",
          },
        },
        container: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1.5),
          padding: theme.spacing(1.5),
        },
        image: {
          height: 80,
          width: 80,
        },
        descriptionContainer: {
          display: "flex",
          flexDirection: "column",
        },
        highlightedText: {
          fontWeight: 700,
        },
        headerContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        primaryText: {
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        secondaryText: {
          display: "none",
        },
        arrowIcon: {
          width: "24px",
          height: "24px",
        },
      },
    },
    MyLocationButton: {
      styleOverrides: {
        root: {
          height: 48,
          width: 48,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid #E2E2E4`,
          boxShadow:
            "0px 2px 4px 0px rgba(0, 0, 0, 0.1),0px 8px 8px 0px rgba(0, 0, 0, 0.09),0px 18px 11px 0px rgba(0, 0, 0, 0.05),0px 32px 13px 0px rgba(0, 0, 0, 0.01),0px 50px 14px 0px rgba(0, 0, 0, 0)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
        icon: {
          height: 24,
          width: 24,
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
        },
        cardActionArea: {
          height: "100%",
          width: "100%",
          "&:after": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.84))",
          },
        },
        backgroundImage: {
          width: "100%",
          height: "100%",
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: "6px 5px",
          zIndex: 1,
        },
        highlightIconChip: {
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          height: "24px",
          width: "24px",
          padding: 0,
          color: "#FFFFFF",
          backgroundColor: "#F03D3D",
          fontWeight: 700,
          marginRight: "auto",
          "& .MuiChip-label": {
            padding: "0px",
            margin: "auto",
          },
        },
        highlightIcon: {
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
        },
        highlightTextChip: {
          display: "none",
          padding: 0,
          color: "#FFFFFF",
          backgroundColor: "#F03D3D",
          fontWeight: 400,
          marginRight: "auto",
        },
        levelChip: {
          display: "none",
          width: "24px",
          height: "24px",
          borderRadius: "100px",
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.light,
          fontSize: "0.75rem",
          fontWeight: 700,
          marginLeft: "auto",
          "& .MuiChip-label": {
            padding: "0px",
          },
        },
        newShopChip: {
          display: "none",
        },
        comingSoonChip: {
          display: "none",
        },
        adsChip: {
          padding: theme.spacing(0.5, 1),
          width: "fit-content",
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            color: theme.palette.grey[200],
            textTransform: "capitalize",
          },
        },
        fallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.common.white,
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        fallbackImageIcon: {
          height: "48px",
          width: "48px",
          zIndex: 1,
        },
        avatar: {
          width: "50px",
          height: "50px",
          borderRadius: "4px",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        subHeader: {
          fontSize: "0.75rem",
          color: theme.palette.common.white,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "90%",
          "&.sub-category-text": {
            display: "none",
          },
          "&.booth-name-text": {
            display: "none",
          },
          "&.location-text": {},
        },
        cardHeader: {
          padding: theme.spacing(2),
          paddingBottom: theme.spacing(1),
          position: "absolute",
          minHeight: "60px",
          width: "100%",
          bottom: "0px",
          zIndex: 1,
          "& .MuiCardHeader-title": {
            lineHeight: 1.3,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            fontWeight: 700,
          },
          "& .MuiCardHeader-content": {
            color: theme.palette.common.white,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-avatar": {
            marginRight: theme.spacing(1),
          },
        },
      },
    },
    LoadingScreen: {
      defaultProps: {
        logoMotionVariant: null,
      },
      styleOverrides: {
        backgroundLoading: {
          display: "none",
        },
      },
    },
    CarouselNavigation: {
      defaultProps: {
        carouselOption: {},
      },
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
        },
        carousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
        },
        carouselItem: {
          carouselItem: {
            "&.is-active": {
              zIndex: 1,
            },
            "&:not(.is-visible)": {},
            "&.is-move": {},
          },
        },
      },
    },
    CarouselNavigationMenu: {
      styleOverrides: {
        root: {},
      },
    },
    ErrorDialog: {
      styleOverrides: {
        root: {},
        paper: {},
        title: {},
        content: {},
        contentText: {},
        buttonContainer: {},
        button: {},
      },
    },
    PostPage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gridAutoFlow: "row",
          justifyItems: "center",
          gap: theme.spacing(1.5),
          "&>*": {
            width: "100%",
          },
        },
        emptyDataWrapper: {
          paddingTop: "40%",
          paddingBottom: 0,
        },
        /**
         * change eventGroupSelectorButton to PostGroupSelectorButton
         */
        postGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          marginBottom: theme.spacing(1.5),
        },
        toggleButtonGroup: {
          background: "#E4E2E3",
          padding: theme.spacing(0.5),
          borderRadius: "9999px",
          width: "344px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "9999px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "9999px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "9999px",
            fontSize: "1rem",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
            flex: 1,
            color: theme.palette.text.primary,
            height: "38px",
            "&.Mui-selected": {
              fontWeight: 700,
              color: theme.palette.primary.contrastText,
            },
          },
        },
      },
    },
    PostCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "12px",
          padding: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: "302px",
          border: "1px solid #E2E2E4",
          "&.MuiCardContent-dense": {
            "& .MuiCardContent-root ": { padding: theme.spacing(2) },
          },
        },
        cardMedia: {
          width: "100%",
          height: "207px",
          borderRadius: "none",
          objectFit: "cover",
          position: "relative",
        },
        cardContent: {
          height: "95px",
          padding: theme.spacing(0.5, 1.5),
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:last-child": {
            paddingBottom: theme.spacing(0.5),
          },
          [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(0.5, 1.5),
          },
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          fontSize: "0.875rem",
          fontWeight: 700,
          lineHeight: 1,
          wordBreak: "break-word",
        },
        iconContainer: {
          display: "flex",
          alignItems: "center",
          width: "auto",
          "& .MuiSvgIcon-root": {
            position: "relative",
            top: "-2px",
            width: "12px",
            height: "12px",
          },
        },
        cardInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          fontSize: "0.75rem",
          gap: theme.spacing(0.5),
          "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            fontSize: "0.75rem",
            WebkitLineClamp: 1,
          },
        },
        venueLogoContainer: {
          display: "none",
          "& .MuiCardMedia-root": {
            maxWidth: "120px",
          },
        },
        cardContentStack: {},
        /**
         * change duration to publishedDate
         * - durationContainer > publishedDateContainer
         * - duration > publishedDateText
         */
        publishedDateContainer: {
          color: theme.palette.text.secondary,
          borderRadius: "80px",
          width: "fit-content",
        },
        publishedDateText: {
          fontSize: "0.75rem",
        },
        recommendText: {
          width: "100%",
          backgroundColor: theme.palette.primary.main,
          position: "absolute",
          bottom: "-1px",
          left: 0,
          borderRadius: "4px 4px 0px 0px",
          textAlign: "center",
          color: theme.palette.primary.contrastText,
        },
        chipContainer: { display: "none" },
        recommendTextContainer: {},
      },
    },
    CoolDownProgress: {
      styleOverrides: {
        root: {
          display: "none",
        },
        linearProgress: {
          "& .MuiLinearProgress-bar": {
            transition: "transform .1s linear",
          },
        },
      },
    },
    ScrollableTab: {
      styleOverrides: {
        root: {
          [theme.breakpoints.up("md")]: {
            maxWidth: "85vw",
          },
        },
        scrollContainer: {
          [theme.breakpoints.up("md")]: {
            maxWidth: "85vw",
            padding: theme.spacing(0, 6.25),
          },
          display: "flex",
          alignItems: "center",
          position: "relative",
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTabs-scrollButtons": {
            display: "flex",
            zIndex: 2,
            "&.Mui-disabled": {
              opacity: 0,
              visibility: "hidden",
            },
          },
          "&:not(.MuiTabs-vertical) .MuiTabs-scrollButtons": {
            position: "absolute",
            "&:first-of-type": {
              left: 0,
            },
            "&:last-of-type": {
              right: 0,
            },
          },
          "&.MuiTabs-vertical .MuiTabs-scrollButtons": {
            transform: "rotate(90deg)",
            position: "absolute",
            "&:first-of-type": {
              top: 0,
            },
            "&:last-of-type": {
              bottom: 0,
            },
          },
        },
        iconButton: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "50%",
          fill: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
      },
    },
    NewShopChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1),
          width: "fit-content",
          height: "20px",
          borderRadius: "24px",
          backgroundColor: theme.palette.error.main,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    ComingSoonChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1),
          width: "fit-content",
          height: "20px",
          borderRadius: "24px",
          backgroundColor: theme.palette.warning.secondary,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    HighlightChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1),
          width: "fit-content",
          height: "20px",
          borderRadius: "24px",
          backgroundColor: theme.palette.error.main,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    HorizontalScrollBarWithButton: {
      styleOverrides: {
        root: {},
        content: {},
      },
    },
    ParkingFinderContainer: {
      styleOverrides: {
        root: {
          "& .MuiDialog-container": {
            "& .MuiDialog-paper": {
              margin: 0,
              width: "calc(100% - 32px)",
            },
          },
        },
      },
    },
    ParkingLocationButton: {
      styleOverrides: {
        button: {
          height: 40,
          width: 40,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid #E2E2E4`,
          borderRadius: "8px",
          boxShadow:
            "0px 2px 4px 0px rgba(0, 0, 0, 0.1),0px 8px 8px 0px rgba(0, 0, 0, 0.09),0px 18px 11px 0px rgba(0, 0, 0, 0.05),0px 32px 13px 0px rgba(0, 0, 0, 0.01),0px 50px 14px 0px rgba(0, 0, 0, 0)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
        carIcon: {
          height: 24,
          width: 24,
        },
        dialog: {
          "& .MuiDialog-container": {
            "& .MuiDialog-paper": {
              margin: 0,
              borderRadius: 0,
              boxShadow: "none",
              position: "fixed",
              height: 142,
              width: 200,
              background: "transparent",
              right: 16,
              bottom: 160,
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
            },
          },
        },
        tooltip: {
          background: theme.palette.primary.main,
          width: 170,
          height: 90,
          padding: theme.spacing(3, 2),
          position: "absolute",
          margin: 0,
          borderRadius: 0,
          boxShadow: "none",
          marginRight: theme.spacing(1),
        },
        tooltipPrimaryText: {
          fontSize: "1rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          lineHeight: 1.12,
        },
        tooltipSecondaryText: {
          fontSize: "0.875rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          lineHeight: 1.12,
        },
        tapHereIcon: {
          height: 32,
          width: 32,
          color: theme.palette.primary.contrastText,
          position: "absolute",
          top: 24,
          right: 16,
        },
        closeButton: {
          width: 24,
          height: 24,
          backgroundColor: theme.palette.primary.main,
          borderRadius: "50%",
          position: "absolute",
          top: 4,
          right: 4,
          "& svg": {
            height: 8,
            width: 8,
            color: theme.palette.primary.contrastText,
          },
        },
        container: {
          display: "flex",
          position: "fixed",
          bottom: 160,
          right: 16,
        },
        activeButton: {
          height: 40,
          width: 40,
          backgroundColor: theme.palette.primary.main,
          border: "none",
          borderRadius: "8px",
          position: "fixed",
          bottom: 160,
          boxShadow:
            "0px 2px 4px 0px rgba(0, 0, 0, 0.1),0px 8px 8px 0px rgba(0, 0, 0, 0.09),0px 18px 11px 0px rgba(0, 0, 0, 0.05),0px 32px 13px 0px rgba(0, 0, 0, 0.01),0px 50px 14px 0px rgba(0, 0, 0, 0)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
          "& svg": {
            color: theme.palette.primary.contrastText,
          },
          ":hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
      },
    },
    ClearParkingModal: {
      styleOverrides: {
        root: {
          "& .MuiDialog-container": {
            "& .MuiDialog-paper": {
              margin: theme.spacing(2),
              padding: theme.spacing(3),
              gap: theme.spacing(2),
              position: "fixed",
              bottom: 16,
            },
          },
        },
        title: {
          fontSize: "1.5rem",
          fontWeight: 700,
          textAlign: "center",
          lineHeight: 1.2,
          padding: theme.spacing(0, 3),
        },
        content: {
          fontSize: "0.8rem",
          color: theme.palette.text.secondary,
          padding: 0,
          textAlign: "center",
        },
        actions: {
          padding: 0,
          "& .MuiButton-root": {
            flex: 1,
            ":last-of-type": {
              borderColor: theme.palette.divider,
              color: theme.palette.text.primary,
            },
          },
        },
        closeButton: {
          width: 24,
          height: 24,
          backgroundColor: theme.palette.background.default,
          borderRadius: "50%",
          position: "absolute",
          top: 12,
          right: 12,
          "& svg": {
            height: 8,
            width: 8,
          },
        },
      },
    },
    NoStepFreeRouteModal: {
      styleOverrides: {
        root: {
          "& .MuiDialog-container": {
            "& .MuiDialog-paper": {
              margin: theme.spacing(2),
              padding: theme.spacing(3),
              gap: theme.spacing(2),
              position: "fixed",
              bottom: 16,
              [theme.breakpoints.up("md")]: {
                position: "relative",
                bottom: "auto",
              },
            },
          },
        },
        title: {
          fontSize: "1.5rem",
          lineHeight: 1.2,
          fontWeight: 700,
          textAlign: "center",
          padding: theme.spacing(0, 3),
        },
        content: {
          fontSize: "0.8rem",
          color: theme.palette.text.secondary,
          padding: 0,
          textAlign: "center",
        },
        actions: {
          padding: 0,
          "& .MuiButton-root": {
            flex: 1,
            borderRadius: "12px",
            textTransform: "none",
          },
        },
        closeButton: {
          width: 24,
          height: 24,
          backgroundColor: theme.palette.background.default,
          borderRadius: "50%",
          position: "absolute",
          top: 12,
          right: 12,
          "& svg": {
            height: 8,
            width: 8,
          },
        },
        kioskCloseButton: {
          display: "none",
        },
      },
    },
  },
})
